//imports
import {
    CHANGE_DETAILS_OPEN_MODAL,
    CHANGE_DETAILS_CLOSE_MODAL,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    change: null,
    openModal: false,
}

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case CHANGE_DETAILS_OPEN_MODAL:
            return { ...state, openModal: true, change: action.payload }

        case CHANGE_DETAILS_CLOSE_MODAL:
            return { ...state, openModal: false, change: null }

        case CLEAR_REDUX:
            return ["", "CHANGE_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};